/*
  Splash hero background video — opts motion-allowed viewports into
  playback explicitly, rather than relying on an `autoplay` HTML
  attribute (removed in highrise-splash.liquid on purpose: `autoplay`
  makes browsers start loading/buffering as soon as the element is
  parsed, before any of this runs — CSS `display: none` alone doesn't
  reliably stop that eager load everywhere). Plays at every viewport
  width, full-bleed same as desktop; only prefers-reduced-motion opts a
  visitor out, and live-reacts if that OS-level setting changes
  mid-visit.
*/
(function () {
  function init() {
    var video = document.querySelector('.hn-splash-hero__video');
    if (!video) return;

    /* No poster image at all, on purpose (see the comment on the wrap
       element in highrise-splash.liquid) — there's deliberately nothing
       left to set one from. The video's own CSS background-color (see
       highrise-splash.css) covers the otherwise-black box a <video>
       element can render before it has a frame to show. */

    /* Defensive, even though Shopify's video_tag filter is documented to
       add this on its own for the merchant-uploaded path: setting it
       directly here too means the theme-default filler <video> (which
       already has it inline) and the merchant-video path both
       definitely carry it, with no dependency on trusting the filter's
       exact output for every format Shopify might transcode the source
       into. Required for iOS Safari to even consider inline (non-
       fullscreen) autoplay at all. */
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');

    function attemptPlay() {
      if (!motionQuery.matches) return;
      video.muted = true;
      var playResult = video.play();
      if (playResult && typeof playResult.catch === 'function') {
        playResult.catch(function () {
          /* Expected and routine on a real phone, not just an edge
             case: this fires the instant the script runs, which on a
             real mobile connection is very often before the video has
             buffered enough data to actually start — rejecting here is
             normal, not a dead end, because the listeners below retry
             once there's real data (or a real gesture) to work with.
             Previously this was the only attempt ever made, and a
             reject here was final — the video just sat on its poster
             frame (the same photo as the "fallback") forever, which is
             the exact bug this retry logic fixes. */
        });
      }
    }

    function sync() {
      if (motionQuery.matches) {
        attemptPlay();
      } else {
        video.pause();
      }
    }

    /* Retries as the video actually becomes able to play, instead of
       relying on the single attempt in sync() succeeding on the first
       try. */
    video.addEventListener('loadeddata', attemptPlay);
    video.addEventListener('canplay', attemptPlay);

    /* iOS Low Power Mode blocks autoplay outright — gesture or not,
       muted or not, playsinline or not — as a battery-saving measure
       independent of the usual autoplay permission rules. The one
       reliable way around it is retrying from inside an actual user
       gesture; this fires at most once, on whichever qualifying
       interaction happens first anywhere on the page, and only bothers
       retrying if the video is in fact still paused by then. */
    function retryOnFirstInteraction() {
      if (!video.paused) return;
      attemptPlay();
    }
    document.addEventListener('touchstart', retryOnFirstInteraction, { passive: true, once: true });
    document.addEventListener('click', retryOnFirstInteraction, { once: true });
    document.addEventListener('keydown', retryOnFirstInteraction, { once: true });

    sync();
    motionQuery.addEventListener('change', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
